import { getAxiosConfig, getDomainOrigin } from 'utils/serverConfig';
import axios from 'axios';
import {
    ICommissionDownload,
    ICommissionSummaryRequest,
    ICommissionSummaryResponse,
} from './types';

export const getCommissionSummary = async (
    request: ICommissionSummaryRequest,
    partnerId
): Promise<ICommissionSummaryResponse> => {
    try {
        const response = await axios({
            method: 'POST',
            url: `${getDomainOrigin()}/api/mpos/partner/${partnerId}/order/commission-summary`,
            ...getAxiosConfig(),
            data: request,
        });

        const { data, status } = response;
        if (status === 200) {
            return {
                status: true,
                ...data,
            };
        }

        return {
            status: false,
        } as ICommissionSummaryResponse;
    } catch (e: any) {
        if (e?.response?.status === 401) {
            window.location.href = '/login';
        }
        return {
            status: false,
        } as ICommissionSummaryResponse;
    }
};

export const downloadCommissionReport = async (
    request: ICommissionSummaryRequest,
    partnerId,
    onProgress?: (progress: number) => void
): Promise<ICommissionDownload> => {
    try {
        const response = await axios({
            method: 'POST',
            url: `${getDomainOrigin()}/api/mpos/partner/${partnerId}/order/commission-summary/download`,
            ...getAxiosConfig(),
            data: request,
            responseType: 'blob',
            onDownloadProgress: (progressEvent) => {
                if (onProgress) {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    onProgress(percentCompleted);
                }
            },
        });

        const { data, status } = response;
        if (status === 200) {
            return {
                status: true,
                blobData: data,
            };
        }

        return {
            status: false,
        } as ICommissionDownload;
    } catch (e: any) {
        if (e?.response?.status === 401) {
            window.location.href = '/login';
        }
        return {
            status: false,
        } as ICommissionDownload;
    }
};
